import "intersection-observer";

import React, {
  Fragment,
  Suspense,
  useEffect,
  useContext,
  lazy,
  useRef,
} from "react";

import {
  Router,
  Switch,
  Route,
  useLocation,
  useHistory,
  Redirect,
} from "react-router-dom";

import { observer } from "mobx-react-lite";

import InView from "./misc/InView";
//import { setupPlayerLinks } from "lib/player_util";
import Player from "./components/parts/Player";
import LoadingSection from "./components/parts/LoadingSection";

// not lazy to avoid layout shift
import NowPlaying from "./components/NowPlaying";

const ArtistBioPage = lazy(() =>
  import(/* webpackChunkName: "artbiopg" */ "./components/ArtistBioPage")
);

const ArtistPage = lazy(() =>
  import(/* webpackChunkName: "artpg" */ "./components/ArtistPage")
);
const StationPage = lazy(() =>
  import(/* webpackChunkName: "stnpg" */ "./components/StationPage")
);
const ExploreStations = lazy(() =>
  import(/* webpackChunkName: "xstns" */ "./components/ExploreStations")
);
const MyStations = lazy(() =>
  import(/* webpackChunkName: "mstns" */ "./components/MyStations")
);
const Menu = lazy(() =>
  import(/* webpackChunkName: "menu" */ "./components/parts/Menu")
);
//import TopBanner from "./components/TopBanner";
const Footer = lazy(() =>
  import(/* webpackChunkName: "ftr" */ "./components/parts/Footer")
);
const SongShow = lazy(() =>
  import(/* webpackChunkName: "SongShow" */ "./songs/show.js.jsx")
);
const BandCentral = lazy(() =>
  import(/* webpackChunkName: "bc" */ "./components/BandCentral")
);
const UserPage = lazy(() =>
  import(/* webpackChunkName: "usr" */ "./components/UserPage")
);
const UserAbout = lazy(() =>
  import(/* webpackChunkName: "usrabt" */ "./components/UserAbout")
);
const UserAccount = lazy(() =>
  import(/* webpackChunkName: "usracct" */ "./components/UserAccount")
);
const VideoModal = lazy(() =>
  import(/* webpackChunkName: "vdeomdl" */ "./components/modals/VideoModal")
);



function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

import { playerStoreContext } from "lib/player_store";
import history from "lib/history";

const TrackHistory = () => {
  const history = useHistory();
  const store = useContext(playerStoreContext);

  useEffect(() => {
    // console.log(
    //   "HISTORY LISTEN first time",
    //   window.location.pathname,
    //   "firsttime:",
    //   store.firstTime,
    //   history.location
    // );
    store.set_pathname(history.location.pathname);
  }, []);

  useEffect(() => {
    // console.log("TRACKHISTORY");
    const unlisten = history.listen((location, _action) => {
      // console.log(
      //   "HISTORY LISTEN",
      //   history,
      //   window.location.pathname,
      //   "firsttime:",
      //   store.firstTime,
      //   location,
      //   action
      // );
      store.set_pathname(location.pathname);

      // back button from react route to turbolinks rendered
      // if (action == "POP") {
      //   Turbolinks.visit(location.pathname);
      // }
      // window.Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
      //   location.pathname,
      //   window.Turbolinks.uuid()
      // );


      // GA4 Enhancement Mmasurement enabled by default sends pageviews when browser history state changes
      // 2023-02-6 https://support.google.com/analytics/answer/11403294?hl=en#zippy=%2Cgoogle-tag-websites
      // console.log("APP.js: _ping GA");
      // window.ga("send", "pageview", {
      //   page: window.location.pathname,
      // });


    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
};

// const LegacyPages = () => {
//   const location = useLocation();
//   const history = useHistory();
//   console.log("Legacy", location, history);
//   if (history.action == "POP") {
//     console.log("Turbolinks => ", location.pathname);
//     Turbolinks.visit(location.pathname);
//   }
//   return null;
// };

//import { withRouter } from "react-router-dom";

const App = observer(() => {
  const store = useContext(playerStoreContext);

  useEffect(() => {
    //    setupPlayerLinks();
    document.querySelector("body").classList.remove("splash");
  }, []);

  const playerRef = useRef();

  const skip = () => {
    playerRef.current.skip();
  };

  const {
    // autoplayOverlayVariant,
    // autoplayOverlay,
    songInfo: { artist },
    airplayUX,
    youtubeID,
  } = store;

  console.log("App artist:", artist);

  return (
    <Fragment>
      <div id="masthead-outer">
        <Suspense fallback={null}>
          {youtubeID && <VideoModal youtubeID={youtubeID} />}
        </Suspense>
        <Router history={history}>
          <TrackHistory />
          <ScrollToTop />
          <div className="App">
            <Suspense fallback={<LoadingSection type="loading-section" />}>
              <Menu />
            </Suspense>
            <Switch>
              <Route exact strict path="/">
                {/* redirect if nothing to show for nowplaying  */}
                {!artist ? (
                  <Redirect to="/browse_music/genre/Recommended" />
                ) : (
                  <Fragment>
                    {!airplayUX && <NowPlaying skip={skip} />}

                    <Suspense
                      fallback={<LoadingSection type="loading-section" />}
                    >
                      <InView ckey={artist}>
                        <ArtistPage />
                      </InView>
                    </Suspense>

                    <Suspense fallback={null}>
                      <InView>
                        <Footer />
                      </InView>
                    </Suspense>
                  </Fragment>
                )}
              </Route>
              <Route exact path="/browse_music">
                <Redirect to="/browse_music/genre/Recommended" />
              </Route>
              <Route
                path={[
                  "/browse_music/genre/:genre",
                  "/artists/search",
                  "/catalog/*",
                ]}
              >
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <ExploreStations />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>
              <Route path="/my_song_history">
                <Redirect to="/my_stations" />
              </Route>
              <Route
                path={[
                  "/my_mixes",
                  "/users/:user_id/mixes",
                  "/users/:user_id/mixes/new",
                  "/users/:user_id/mixes/:mix_id/edit",
                  "/my_stations",
                  "/users/:user_id/stations",
                  "/song_ratings/favorites",
                  "/song_ratings/bans",

                  "/my_independent_artists",
                  "/guests/history",
                  "/songs/search",
                ]}
              >
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <MyStations />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route path="/music/:artist/:song/video">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <SongShow />
                </Suspense>
              </Route>

              <Route
                exact
                path={[
                  "/music/:artist/_full_bio",
                ]}
              >
                <Suspense fallback={<LoadingSection type="loading-section" />}>
                  <InView>
                    <ArtistBioPage />
                  </InView>
                </Suspense>
                <Suspense fallback={null}>
                  <InView>
                    <Footer />
                  </InView>
                </Suspense>
              </Route>

              <Route
                exact
                path={[
                  "/music/:artist",
                  "/music/:artist/_full_bio",
                  // established artists have deprecated routes at least /_more_songs and /artist_pictures
                  "/music/:artist/:feature(events|videos|images|fans|comments|reviews)",
                  "/music/:artist/:feature(reviews)/:review_song",
                ]}
              >

                {artist && !airplayUX && <NowPlaying skip={skip} />}
                <Suspense fallback={<LoadingSection type="loading-section" />}>
                  <InView>
                    <ArtistPage />
                  </InView>
                </Suspense>
                <Suspense fallback={null}>
                  <InView>
                    <Footer />
                  </InView>
                </Suspense>
              </Route>

              <Route path="/band_central">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <BandCentral />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route exact path="/stations/:station_id">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <StationPage />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route exact path="/users/:user_id">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <UserPage />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route exact path="/users/:user_id/about">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <UserAbout />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route exact path="/users/:user_id/account">
                <Suspense fallback={<LoadingSection type="loading-page" />}>
                  <UserAccount />
                </Suspense>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>
              </Route>

              <Route>
                <div>404</div>
              </Route>
            </Switch>
            <Player ref={playerRef} />
          </div>
        </Router>
      </div>
    </Fragment>
  );
});

//App.whyDidYouRender = true;

export default App;

// $(() => {
//   ReactDOM.render(<App />, document.querySelector("#jango_player_app"));
// });
